











































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import type { SpecType } from './GoodsSpecifications.vue'
import {getUser} from '@/store/userStore'

type GoodsSku = {
  // id: Math.random(), // 换成接口获取id，后续可直接用于保存
  id?: number | undefined
  specType1?: string | undefined
  specType1Value?: string | undefined
  specType2?: string | undefined
  specType2Value?: string | undefined
  specType3?: string | undefined
  specType3Value?: string | undefined
  price?: number
  pv?: number
  contributionQty?: number
  energyQty?: number
  contributionRate?: number
  energyRate?: number
  inventory?: number
  inStockInventory?: number
  sort?: number
  putStatus?: boolean
  repurchasePrice?: number
  repurchasePv?: number
  repurchaseContributionQty?: number
  repurchaseEnergyQty?: number
}

@Component({
  components: {}
})
export default class GoodsSpecifications extends Vue {
  @Prop({ type: Array, default: (): Array<GoodsSku> => [] })
  private value!: GoodsSku[]
  @Prop({ type: Array, default: (): Array<SpecType> => [] })
  private specTypeList!: SpecType[]
  @Prop({ type: Number, default: 1.5 }) private buyGxRate!: number // 默认贡献值比例
  @Prop({ type: Number, default: 2 }) private buyNlRate!: number // 默认能量值比例
  @Prop({ type: Boolean, default: false }) private showRepurchase!: boolean

  private  userInfo = getUser()
  // 最大PV 0.2 20%
  private maxPvRate = 0.2
  // 最小PV 0.03 3%
  private minPvRate = 0.03
  // 最大价格
  private maxPrice = 10000
  // 最小价格
  private minPrice = 10

  private settingParam: any = {
    price: undefined,
    pv: undefined,
    inStockInventory: undefined,
    contributionRate: undefined,
    energyRate: undefined
  }

  // 清理参数
  public clearParam(): void {
    this.settingParam = {
      price: undefined,
      pv: undefined,
      inStockInventory: undefined,
      contributionRate: undefined,
      energyRate: undefined
    }
  }

  // sku 使用计算属性做伪双向绑定
  private get tableData() {
    return this.value
  }
  private set tableData(newValue) {
    this.$emit('input', newValue)
  }

  // 填写进度
  private get percentage() {
    if (!this.tableData || this.tableData.length == 0) {
      return 0
    }
    const ts = this.tableData.filter((e) => e.price && e.price > 0)
    return Number(((ts.length / this.tableData.length) * 100).toFixed(2))
  }

  @Watch('specTypeList', { deep: true })
  private specTypeListWatch() {
    this.generateSkuList()
  }

  private generateSkuList = this.disableSpecType()
  private disableSpecType() {
    return this.debounce(async () => {
      // 生成新的sku，做补充
      let currentLevel = 1
      const tempSkuList = this.specTypeList.reduce(
        (tempList, specType) => {
          const newResults: GoodsSku[] = []
          if (!specType.specItemList || specType.specItemList.length <= 0) {
            return tempList
          }
          let sort = 0
          if (currentLevel == 1) {
            specType.specItemList.forEach((item) => {
              newResults.push({
                specType1: specType.name,
                specType1Value: item.name,
                price: undefined,
                pv: undefined,
                inStockInventory: undefined,
                contributionQty: undefined,
                energyQty: undefined,
                contributionRate: this.buyGxRate,
                energyRate: this.buyNlRate,
                putStatus: true,
                sort: sort++
              })
            })
          } else {
            tempList.forEach((temp) => {
              specType.specItemList.forEach((item) => {
                const res: GoodsSku = {
                  ...temp
                }
                if (currentLevel == 2) {
                  res.specType2 = specType.name
                  res.specType2Value = item.name
                } else if (currentLevel == 3) {
                  res.specType3 = specType.name
                  res.specType3Value = item.name
                }
                res.sort = sort++
                newResults.push(res)
              })
            })
          }
          currentLevel++
          return newResults
        },
        [{}] as GoodsSku[]
      )

      // 与原来的做匹配，匹配规则为
      tempSkuList.forEach((e) => {
        const td = this.tableData.find((i) => {
          return (
            i.specType1 == e.specType1 &&
            i.specType1Value == e.specType1Value &&
            i.specType2 == e.specType2 &&
            i.specType2Value == e.specType2Value &&
            i.specType3 == e.specType3 &&
            i.specType3Value == e.specType3Value
          )
        })
        // 匹配上了则更新
        if (td) {
          e.id = td.id
          e.price = td.price
          e.pv = td.pv
          e.contributionQty = td.contributionQty
          e.energyQty = td.energyQty
          e.contributionRate = td.contributionRate
          e.energyRate = td.energyRate
          e.inventory = td.inventory
          e.inStockInventory = td.inStockInventory
          e.putStatus = td.putStatus
          e.repurchasePrice = td.repurchasePrice
          e.repurchasePv = td.repurchasePv
          e.repurchaseContributionQty = td.repurchaseContributionQty
          e.repurchaseEnergyQty = td.repurchaseEnergyQty
        }
      })
      this.tableData = tempSkuList
    }, 500)
  }

  // 防抖函数
  private debounce(fn: any, delay: number) {
    let debounceTimer: number
    return function () {
      // const context = this
      const args = arguments
      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(function () {
        fn.apply(args)
      }, delay)
    }
  }

  // 批量设置
  private batchSetting() {
    this.tableData.forEach((e) => {
      // price: undefined,
      // pv: undefined,
      // inStockInventory: undefined,
      console.log(this.settingParam)
      if (this.settingParam.price) {
        e.price = this.settingParam.price
      }
      if (this.settingParam.pv) {
        e.pv = this.settingParam.pv
      }
      if (this.settingParam.inStockInventory) {
        e.inStockInventory = this.settingParam.inStockInventory
      }
      if (this.settingParam.contributionRate) {
        e.contributionRate = this.settingParam.contributionRate
      }
      if (this.settingParam.energyRate) {
        e.energyRate = this.settingParam.energyRate
      }

      this.rulePv(e)

      // 计算贡献值
      if (e.pv && e.contributionRate) {
        e.contributionQty = parseInt(
          Number(e.pv * e.contributionRate).toFixed(0)
        )
      } else {
        e.contributionQty = 0
      }
      // 计算能量值
      if (e.pv && e.energyRate) {
        e.energyQty = Math.floor(Number(e.pv * e.energyRate))
        console.log(e.energyQty   )
      } else {
        e.energyQty = 0
      }
    })
  }

  private changePrice(e: any){
    // 限制价格
    if(this.userInfo.user.role == 2){
      // 店铺角色，限制价格
      if(e.price < this.minPrice){
        e.price = this.minPrice
        this.$message.error("价格最小为10，最大为10000")
      }else if(e.price > this.maxPrice){
        e.price = this.maxPrice
        this.$message.error("价格最小为10，最大为10000")
      }
    }
    // 限制pv
    this.rulePv(e)
  }

  // 限制pv不能超过 20%
  private rulePv(e: any){
    // 判断pv不能大于价格的20%
    if(!e.pv || e.pv < 0){
      e.pv = 0
    }
    e.pv = parseFloat(Number(e.pv).toFixed(2))
    if(this.userInfo.user.role == 2){
      // 进行限制
      const maxPv = parseFloat(Number(e.price * this.maxPvRate).toFixed(2))
      const minPv = parseFloat(Number(e.price * this.minPvRate).toFixed(2))
      if(e.pv > maxPv){
        e.pv = maxPv
      } else if(e.pv<minPv){
        e.pv = minPv
      }
      console.log("pv:",e.pv)
    }
     this.handleSku(e)
  }

  // 批量设置价格变化
  private changeStPrice(){
    // 价格限制
    if(this.userInfo.user.role == 2){
      // 店铺角色，限制价格
      if(this.settingParam.price < this.minPrice){
        this.settingParam.price = this.minPrice
        this.$message.error("价格最小为10，最大为10000")
      } else if(this.settingParam.price > this.maxPrice){
        this.settingParam.price = this.maxPrice
        this.$message.error("价格最小为10，最大为10000")
      }
    }
    // 更新批量设置的pv
    this.ruleStPv()
  }

  // 限制批量 设置的 pv
  private ruleStPv(){
    if(!this.settingParam.pv){
      return
    }
    this.settingParam.pv = parseFloat(Number(this.settingParam.pv).toFixed(2))
    // 判断pv不能大于价格的20%
    if(this.userInfo.user.role == 2){
      // 进行限制
      let price = 0
      // 获取sku最小值
      const prices: number[] = this.tableData.filter((e: any)=>e.price).map((e: any)=>Number(e.price))
      if(prices && prices.length>0){
        price = Math.min(...prices)
      }
      if(this.settingParam.price){
        price =this.settingParam.price
      }
      const maxPv = parseFloat(Number(price * this.maxPvRate).toFixed(2))
      const minPv = parseFloat(Number(price * this.minPvRate).toFixed(2))
      if(this.settingParam.pv > maxPv){
        this.settingParam.pv = maxPv
      }else if(this.settingParam.pv<minPv){
        this.settingParam.pv = minPv
      }
    }
  }

  // 计算贡献值
  private handleSku(e: any) {

    // 计算贡献值
    if (e.pv && e.contributionRate) {
      e.contributionQty = parseInt(Number(e.pv * e.contributionRate).toFixed(0))
    } else {
      e.contributionQty = 0
    }
    // 计算能量值
    if (e.pv && e.energyRate) {
      e.energyQty = Math.floor(Number(e.pv * e.energyRate))
    } else {
      e.energyQty = 0
    }
  }

  // 清理所有库存
  private cleanInventory() {
    this.$confirm('是否确认清空可售库存？清空后库存为0，且不可售卖。', '提示', {
      confirmButtonText: '清空',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.tableData.forEach((e) => {
        if(e.inventory){
          e.inStockInventory = -e.inventory
        }
      })
    })
  }
  private cleanInventory2(row: GoodsSku) {
    this.$confirm('是否确认清空可售库存？清空后库存为0，且不可售卖。', '提示', {
      confirmButtonText: '清空',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if(row.inventory){
        row.inStockInventory = -row.inventory
      }

    })
  }
}
